import classNames from 'classnames';

import {Icon} from 'components/UIKit/Icon';

type Props = React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
    size?: 'base' | 'large'
    animated?: boolean;
};

export type CallButtonProps = Props;

export const CallButton: React.FC<Props> = ({
    className,
    size = 'base',
    disabled = false,
    animated = false,
    onClick
}: Readonly<Props>) => (
    <button
        className={classNames(`tw-relative tw-inline-block tw-align-middle tw-text-center tw-text-nowrap 
        tw-no-underline tw-select-none tw-border tw-rounded-full focus:tw-outline-none`,
        {
            'tw-py-1 tw-px-3.5': size === 'base',
            'tw-py-1.5 tw-px-5': size === 'large',
            'tw-animate-pulse': animated,
            'tw-text-alternative tw-bg-success tw-cursor-pointer tw-border-success': !disabled,
            'tw-text-default-dimmed tw-bg-default tw-pointer-events-none tw-border-default': disabled
        }, className)}
        type='button'
        disabled={disabled}
        onClick={onClick}
    >
        <span className={classNames('tw-flex-center')}>
            <Icon name='phone-filled' color='light' size={size === 'base' ? 'sm' : 'md'} />
        </span>
    </button>
);
